import styled from 'styled-components'
import { media } from '../../utils/media'

export const Content = styled.div`
  flex: 1 0 auto;
  padding: 18px;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  ${media.tablet`
    padding: 40px;
  `}

  font-size: 18px;
  color: #172129;
  line-height: 24px;
  // white-space: pre-line;
  margin-top: env(safe-area-inset-top);

  h1 {
    font-family: Nunito;
    font-size: 26px;
    font-weight: 900;
    color: #12385b;
    text-align: center;
    margin-bottom: 18px;

    ${media.tablet`
      font-size: 54px;
    `}
  }
`



// WEBPACK FOOTER //
// ./src/atoms/Content/index.tsx